@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col">
      <div class="w-full mb-2">
        <div class="leading-6 font-medium">{{ field.label | localize }}</div>
        @if (field.hint) {
          <div class="text-md text-secondary">{{ field.hint | localize }}</div>
        }
      </div>
      <div class="flex flex-col xl:flex-row w-full">
        <div class="w-full xl:w-1/2 h-120">
          <single-geoposition-map [geopositionSummaryList]="geopositionSummaryList" [canClickOnMap]="true"
          (geopositionSummaryListChanged)="onGeopositionSummaryListChanged($event)"></single-geoposition-map>
        </div>
        <div class="basis-full xl:basis-1/2 xl:ml-4">
          @if (googleAddress) {
            <fuse-card class="flex flex-col px-8 py-6 pb-4 mb-4 bg-primary text-on-primary" #fuseCard>
              <div class="text-xl">{{ googleAddress['name']}}</div>
              <div class="text-md">{{ googleAddress.vicinity }}</div>
            </fuse-card>
          }
          <p class="text-lg font-semibold text-primary my-2">{{ 'searchAddress' | transloco }}</p>
          <form [formGroup]="searchForm" class="flex items-center basis-full mt-2"
            (ngSubmit)="search()">
            <mat-form-field [ngClass]="{'basis-4/5': !isUpdate, 'w-full': isUpdate}" appearance="fill">
              <mat-label>{{ 'address' | transloco }}</mat-label>
              <input matInput maxlength="1024" [placeholder]="'addressAssistantField.addressExample' | transloco" formControlName="address"
                autocomplete="off" />
              </mat-form-field>
              <button mat-raised-button type="submit" class="ml-4" color="primary">
                {{ 'search' | transloco }}
              </button>
            </form>
            <form [formGroup]="formWithLocation" class="flex items-center basis-full mt-2">
              <mat-form-field class="basis-2/5" appearance="fill">
                <mat-label>{{ 'latitude' | transloco }}</mat-label>
                <input matInput type="number" [placeholder]="'latitude' | transloco" formControlName="latitude"
                  autocomplete="off" />
                </mat-form-field>
                <mat-form-field class="basis-2/5 ml-4" appearance="fill">
                  <mat-label>{{ 'longitude' | transloco }}</mat-label>
                  <input matInput type="number" [placeholder]="'longitude' | transloco" formControlName="longitude"
                    autocomplete="off" />
                  </mat-form-field>
                  <button mat-raised-button type="submit" class="ml-4" color="primary" [disabled]="!canReloadMap()" (click)="reloadMap()">
                    {{ 'reloadMap' | transloco }}
                  </button>
                </form>
                <div>
                  <p class="mb-4">{{"addressAssistantField.noSearchNeeded" | transloco}}</p>
                  <p class="mb-4">{{"addressAssistantField.adjustCoordinates" | transloco}}</p>
                  <p class="mb-4">{{"addressAssistantField.pasteCoordinates" | transloco}}</p>
                </div>
              </div>
            </div>
          </div>
        }
      } @else {
        <div class="flex items-center">
          @if (!googleAddress?.placeId && googleAddress?.latitude === 0 && googleAddress?.longitude === 0) {
            <mat-icon class="mr-1" [svgIcon]="'mat_outline:error_outline'" [ngStyle]="{'color':'orange'}" matTooltip="{{'addressWithouthGeolocation' | transloco}}"></mat-icon>
          }
          {{ googleAddress.name }} - {{ googleAddress.vicinity }}
        </div>
      }
